<template>
  <v-dialog v-model="showTable" persistent scrollable max-width="600px">
    <v-card>
      <v-card-title class="px-0">
        <v-col class="text-end py-0 px-0 pb-0" cols="12">
          <v-btn class="pa-0" icon dark @click="clean()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0 pb-0" cols="12">
           <v-icon color="warning">fa-exclamation-circle</v-icon><br>
           <span class="title">Deseja realmente ignorar os erros deste lote?</span>
          <!-- <span v-if="items.historico != 0 && !isLoteComplementar">
            <button @click="historico = true" v-if="!historico" class="button-histor pa-0">
              <v-icon class="py-0 px-1" color="primary" x-small>far fa-eye</v-icon>
              <b style="font-size:12px;color:#118ACA">Histórico</b>
            </button>
            <button @click="historico = false" v-if="historico" class="button-histor pa-0">
              <v-icon class="py-0 px-1" color="primary" x-small>far fa-eye-slash</v-icon>
              <b style="font-size:12px;color:#118ACA">Histórico</b>
            </button>
            <p v-if="!historico" style="font-size:14px;line-height:18px" class="mb-2">
              Caso necessário, edite o retorno <br> da operadora.
            </p>
          </span> -->
          <!-- <p v-if="items.historico == 0 && !isLoteComplementar || isLoteComplementar && !complementar" style="font-size:14px;line-height:18px" class="mb-2">
            Informe o protocolo e data de transmissão <br> do lote e o retorno da operadora.
          </p>
          <p v-if="isLoteComplementar && complementar" style="font-size:14px;line-height:18px" class="mb-2"> -->
          <p style="font-size:14px;line-height:18px" class="mb-2">
            Informe o protocolo, data de transmissão do lote e uma justificativa.
          </p>
        </v-col>
      </v-card-title>
      <!-- <v-card-text v-show="historico" class="px-5 pt-0 pb-10">
        <v-data-table dense :headers="headers" :items="items.historico" hide-default-footer>
          <template v-slot:item="props">
            <tr>
              <td class="text-center pa-2">{{ props.item.dt_alteracao | formatDate }}</td>
              <td class="text-center pa-2">{{ props.item.numero }}</td>
              <td class="text-center pa-2">{{ props.item.dt_protocolo | formatDate }}</td>
              <td class="text-left pa-2">{{ getStatus(props.item) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text> -->
      <v-card-text class="px-10 pt-0 pb-1">
        <v-form ref="ignoraErroForm" :value="formValid">
          <v-col class="py-0 px-6" cols="12">
            <label>Número</label>
            <v-text-field
              v-model="formData.env_op_protocolo"
              placeholder="Protocolo"
              type="number"
              single-line
              outlined
              dense
              :rules="validaProtocolo?[formRules.requiredField, formRules.max20]:null"
            ></v-text-field>
          </v-col>
          <v-col class="py-0 px-6" cols="12">
            <label>Data</label>
            <v-menu
              ref="dtI"
              v-model="dtI"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  dense
                  v-mask="'##/##/####'"
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  label
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @blur="date = parseDate(dateFormatted)"
                  :rules="validaProtocolo?[formRules.requiredField, formRules.typeDateFormated]:null"
                ></v-text-field>
              </template>
              <v-date-picker color="primary" 
                v-model="date"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-6" cols="12">
            <label>Justificativa</label>
            <v-textarea 
              outlined
              flat
              solo
              dense
              height="80px"
              :rules="[formRules.requiredField, formRules.min20]"
              placeholder="Digite a justificativa com no mínimo 20 caracteres"
              v-model="formData.justificativa_tratado"
            ></v-textarea>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-11 pb-1 pt-0">
        <v-col v-if="!historico" class="text-left px-5 pb-4 pt-0" cols="6">
          <v-btn
            height="30px"
            small
            color="primary"
            depressed
            outlined
            @click="clean()"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col v-if="!historico" class="text-right px-5 pb-6 pt-0" cols="6">
          <v-btn
            color="primary"
            height="30px"
            small
            depressed
            @click="save()"
          >
            Salvar
          </v-btn>
        </v-col>
        <!-- <v-col v-if="historico" class="text-center px-5 pb-6 pt-0" cols="12">
          <v-btn
            color="primary"
            height="30px"
            small
            depressed
            @click="historico = false"
          >
            Voltar
          </v-btn>
        </v-col> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex"
import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      formData: {
        env_op_protocolo: null,
        env_op_dt_protocolo: null,
        env_op_status_protocolo: '3',
        erro_protocolo: null,
        dt_alteracao: null,
        justificativa_tratado: null
      },
      showTable: false,
      dateFormatted: null,
      date: null,
      dtI: false,
      status:[
        // {id: "0" , descricao: 'Aguardando retorno'},
        {id: "3" , descricao: 'Aceito'},
        // {id: "1" , descricao: 'Aceito parcialmente'},
        {id: "4" , descricao: 'Rejeitado'}
      ],
      statusList: {
        0: 'Aguardando retorno',
        3: 'Aceito',
        1: 'Aceito parcialmente',
        4: 'Rejeitado'
      },
      formValid: true,
      acao: null,
      historico: false,
      headers: [
        { text: "Atualizado em:", align: "left", value: "dt_alteracao", sortable: false },
        { text: "Protocolo", align: "start", value: "numero", sortable: false },
        { text: "Data protocolo", value: "dt_protocolo", sortable: false },
        { text: "Retorno da oper.", value: "status", sortable: false }
      ],
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
    validaProtocolo(){
      return this.parametros && this.parametros.FAT_SEM_PROTO? false : true
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  watch: {
    dialog(val) {
      this.showTable = val
      this.historico = false
      if(val) {
        this.validations()
      } else {
        this.clean();
      }
    },
    dateFormatted(val) {
      this.formData.env_op_dt_protocolo = this.parseDate(val);
    },
    date(val) { 
      this.dateFormatted = this.formatDate(val);
    },
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    validations() {
        this.formData.env_op_status_protocolo = '3'
        this.formData.dt_alteracao = this.items.dt_alteracao
        this.formData.env_op_protocolo = this.items.env_op_protocolo
        this.date = this.items.env_op_dt_protocolo
        this.justificativa_tratado = this.items.justificativa_tratado
    },
    clean() {
      this.formData = {
        env_op_protocolo: null,
        env_op_dt_protocolo: null,
        erro_protocolo: null,
        dt_alteracao: null,
        justificativa_tratado: null
      },
      this.dateFormatted = null
      this.date = moment().format("YYYY-MM-DD")
      setTimeout(() => {this.date = null},10)
      this.acao = null
      this.$refs.ignoraErroForm.resetValidation()
      this.showClose(false)
    },
    save() {

      this.$refs.ignoraErroForm.validate()
      if(this.formValid ) {
        this.sendForm(this.formData, 'setfltratado')
        this.clean()
      }
    }
  },
  props: {
    complementar: Boolean,
    dialog: Boolean,
    isLoteComplementar: Boolean,
    items: Object,
    parametros: Object,
    sendForm: Function,
    showClose: Function,
  },
};
</script>

<style>
.button-histor:focus {
  outline: none;
}
</style>